import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import { IgCustomTheme, IgLink } from "@intelligems/ig-theme";
import { AgencyCustomerDto } from "@intelligems/ig-types/dtos/agency-customers";
import { Grid, useTheme } from "@mui/material";
import { useGetBillingPortal } from "@src/api/stripe/get-billing-portal";
import { openStripe } from "@src/features/admin/components/utils";

export const ViewColumn = (params: ICellRendererParams<AgencyCustomerDto>) => {
  const getBillingPortal = useGetBillingPortal(false);
  const theme = useTheme();
  if (!params.data?.id) {
    return null;
  }

  return (
    <Grid container alignItems={"center"} columnSpacing={2}>
      {params.data.stripeCustomerId && !params.data.billing ? (
        <Grid item>
          <IgLink
            color={theme.palette.text.tonal.warning}
            disabled={getBillingPortal.isPending}
            onClick={() => {
              getBillingPortal.mutate({
                pathParams: undefined,
                queryParams: undefined,
                body: {
                  stripeCustomerId: params.data!.stripeCustomerId,
                  stripeSubscriptionId: undefined,
                },
              });
            }}
          >
            Create Payment Link
          </IgLink>
        </Grid>
      ) : null}
      <Grid item>
        <IgLink
          onClick={() => {
            openStripe(`customers/${params.data!.stripeCustomerId}`);
          }}
          color={"inherit"}
        >
          View
        </IgLink>
      </Grid>
    </Grid>
  );
};
